import { Spinner } from 'react-bootstrap';
import CustomTableRow from '../CustomTableRow';
import { ICustomTableBodyProps } from './interfaces';
import './style.scss';

const CustomTableBody = <T extends { id?: string }>({
  data,
  columnsMetadata,
  loading,
  onClickRow,
  onActionClick
}: ICustomTableBodyProps<T>) => {
  return (
    <tbody>
      {loading && (
        <tr className="loader">
          <td>
            <Spinner animation="border" />
          </td>
        </tr>
      )}
      {data.map((item: T) => (
        <CustomTableRow<T>
          key={item.id}
          item={item}
          onClick={onClickRow}
          columnsMetadata={columnsMetadata}
          onActionClick={onActionClick}
        />
      ))}
    </tbody>
  );
};

export default CustomTableBody;
